<template>
  <div id="app">
    <search-bar ref="searchBarComponent" @searchBarHeight="getSearchBarHeight">
      <div slot="search-tool">
        <!--  <el-button class="item-btn" @click="exportQuery">导出</el-button> -->
        <!-- <el-button class="item-btn c-btn-sub" @click="clearQuery">重置</el-button> -->
        <!-- <el-button size="mini" type="primary" @click.native='uploadDialolg =true'>点击上传</el-button> -->
        <!-- <el-button class="item-btn" type="primary" @click="getList">查 询</el-button> -->
      </div>
      <div slot="search-cont">

        <!--   <div class="item">
          <div class="item-label">状态</div>
          <el-select v-model="info.status" size="small" slot="prepend" placeholder="请选择状态" @change="getTableData" style="width: 100%;">
            <el-option label="不限" value=""></el-option>
            <el-option label="待推荐" value="0"></el-option>
            <el-option label="待接送" value="1"></el-option>
            <el-option label="待面试" value="2"></el-option>
            <el-option label="面试不通过" value="3"></el-option>
            <el-option label="入职" value="5"></el-option>
            <el-option label="离职" value="6"></el-option>
          </el-select>
        </div>
 -->


        <div class="item">
          <div class="item-label">面试时间</div>
          <el-date-picker v-model="info.begintimeArray" type="daterange" range-separator="-" start-placeholder="开始日期"
            end-placeholder="结束日期" value-format="yyyy-MM-dd" size="mini" @change="interviewTimeChange"></el-date-picker>
        </div>

        <div class="item">
          <div class="item-label">录入时间</div>
          <el-date-picker v-model="info.begintimeArray2" type="daterange" range-separator="-" start-placeholder="开始日期"
            end-placeholder="结束日期" value-format="yyyy-MM-dd" size="mini" @change="inputTimeChange"></el-date-picker>
        </div>


        <div class="item" style="width: 20%;">
          <div class="item-label">工厂</div>
          <el-select v-model="info.company_id" size="small" slot="prepend" placeholder="请选择工厂" @change="workChange"
            filterable>
            <el-option label="不限" value=""></el-option>
            <el-option v-for="(item,index) in companyList" :key='index' :label="item.companyname" :value="item.id"></el-option>
          </el-select>
        </div>

        <div class="item" style="width: 50%;">
          <div class="item-label">关键词搜索</div>
          <div style="width: 300px;">
            <el-input placeholder="请输入内容" v-model="info.key" class="input-with-select" size="small" @keyup.enter.native='searchResume'>
              <el-select v-model="info.key_type" slot="prepend" placeholder="请选择" style="width: 130px" size="small">
                <el-option label="姓名" value="1"></el-option>
                <el-option label="电话号码" value="2"></el-option>
                <!-- <el-option label="面试工厂" value="3"></el-option> -->
                <el-option label="面试职位" value="4"></el-option>
                <el-option label="录入人" value="6"></el-option>
                <el-option label="面试推荐人" value="7"></el-option>
                <el-option label="招聘专员" value="5"></el-option>
              </el-select>
              <el-button slot="append" icon="el-icon-search" @click='searchResume' size="small"></el-button>
            </el-input>
          </div>
        </div>
      </div>
    </search-bar>
    <div class="operation-tool">
      <div @click="exportData()" class="tool-item"> <img src="../../../static/img/btn/export.png" />导出</div>
    </div>

    <div class="l-panel">
     <div class="panel-body">
      <el-table class="l-table" stripe="" :data="tableData" style="width: 100%">
        <el-table-column prop="fullname" label="姓名" width="100" align="left">
          <template slot-scope='{row}'>
            <el-link @click="openDialogResume(row)">{{row.fullname}}</el-link>
          </template>
        </el-table-column>
        <el-table-column prop="telephone" label="手机号码" width="110" align="left"></el-table-column>
        <el-table-column prop="sex_cn" label="性别" width="60" align="left"></el-table-column>
        <el-table-column prop="company_name" label="面试工厂" width="150" align="left"></el-table-column>
        <el-table-column prop="jobs_name" label="面试岗位" width="150" align="left"></el-table-column>
        <el-table-column prop="interview_time" label="面试时间" width="140" align="left"></el-table-column>
        <el-table-column prop="project" label="所属项目" width="140" align="left"></el-table-column>
        <el-table-column prop="wadminname" label="录入人" width="110" align="left"></el-table-column>
        <el-table-column prop="recommendadmin" label="面试推荐人" width="110" align="left"></el-table-column>
        <el-table-column prop="adminname" label="招聘专员" width="110" align="left">
          <template slot-scope='{row}'>
            {{row.adminname}}<img v-if="row.utype==2" style="width:27px ;height: 17px;" src="../../images/icon/agent.png"
              alt />
          </template>
        </el-table-column>
        <el-table-column prop="lastoperatetime" label="跟进时间" width="135" align="left"></el-table-column>
        <el-table-column prop="addtime" label="录入时间" width="135" align="left"></el-table-column>
        <el-table-column prop="supplyer1" label="供应商" width="140" align="left"></el-table-column>
        <el-table-column prop="supplyer2" label="被供应商" width="140" align="left"></el-table-column>
        <el-table-column prop="date" label="状态" width="100" align="left">
          <template slot-scope='{row}'>
            <span v-if='row.status == 0'>待推荐</span>
            <span v-if='row.status == 1'>待接送</span>
            <span v-if='row.status == 2'>待面试</span>
            <span v-if='row.status == 3'>面试不通过</span>
            <span v-if='row.status == 4'>待入职</span>
            <span v-if='row.status == 5'>入职</span>
            <span v-if='row.status == 6'>离职</span>
            <span v-if='row.status == 7'>面试取消</span>
          </template>
        </el-table-column>
        <el-table-column prop="date" label="操作" width="355" align="center" fixed="right">
          <template slot-scope='{row}'>
           <!-- <div class="btn"> -->
              <el-button type="primary" size='mini' @click='infoChange(row.id)' v-if="row.editstatus == 2">信息修改</el-button>
              <el-button type="primary" @click='pushUser(row.id)' size='mini' v-if="row.editstatus == 1">转推</el-button>
              <el-button type="primary" @click='pushUser(row.id)' size='mini' v-if="row.editstatus == 4">添加面试</el-button>
              <el-button type="primary" size='mini' v-if='row.entrystatus == 2' @click='interviewResult(4,row)'>合适</el-button>
              <el-button type="primary" size='mini' @click='interviewResult(3,row)'>不入职</el-button>
              <el-button type="primary" size='mini' v-if='row.entrystatus == 3' @click='entryInfo(row)'>确认入职</el-button>
              <el-button type="primary" size='mini' @click='changeRecommend(row)' v-if="row.zystatus == 2">更换专员</el-button>
              <!-- <el-button type="primary" size='mini' v-if='row.entrystatus == 3'>入职</el-button> -->
              <!-- <el-button type="primary" size='mini' v-if='row.entrystatus == 4'>修改入职</el-button> -->
          <!--  </div> -->

          </template>
        </el-table-column>
      </el-table>
      <div class="c-table-pager">
        <el-pagination  :total="total" @current-change='changePage'> </el-pagination>
      </div>
      </div>
    </div>


    <el-dialog title="入职信息" :visible.sync="dialogVisible1" width="100%" center class='dialog1'>
      <div class="DialogListItem">
        <el-form ref="form" :model="form" label-width="100px" class="formContaier">

          <el-form-item label="员工名称">
            <el-input v-model="form.resume_name"></el-input>
          </el-form-item>

          <el-form-item label="工作类型" >
            <el-select v-model="form.wtype" placeholder="请选择工作类型" @change="wtypeChange">
              <el-option label="正式工" value="1"></el-option>
              <el-option label="临时工" value="2"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="入职时间" >
            <el-date-picker type="datetime" placeholder="选择入职时间" value-format="yyyy-MM-dd HH:mm:ss" v-model="form.entry_time"
              style="width: 100%;"></el-date-picker>
          </el-form-item>

          <el-form-item label="合同时间" v-if="form.wtype == 2">
            <el-date-picker v-model="form.value1" type="daterange" range-separator="-" start-placeholder="合同开始日期"
              value-format="yyyy-MM-dd" end-placeholder="合同结束日期" @change="contractChange"></el-date-picker>
          </el-form-item>

          <el-form-item label="工作制度" >
            <el-select v-model="form.resttype" placeholder="请选择工作制度">
              <el-option v-for='(item,index) in systemList' :key='index' :label="item.label" :value="item.id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="工作时间">
            <el-select v-model="form.worktimeid" placeholder="请选择工作时间">
              <el-option v-for='(item,index) in timeList' :key='index' :label="item.label" :value="item.id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label=""  v-if="form.wtype != 2"></el-form-item>

          <el-form-item label="身份证号码" >
            <el-input v-model="form.idcard" style="width: 95%;"></el-input>
          </el-form-item>

          <el-form-item label="身份证正面">
            <el-upload class="avatar-uploader" :action="baseURL + 'oasystem/uploadimg'" name="idcardfront" :headers="myHeaders"
              :on-success="handleAvatarSuccess">
              <img v-if="form.idcardfront" :src="form.idcardfront" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>

          <el-form-item label="身份证有效期" style="position: relative;">
            <el-date-picker v-model="form.idcardtime" type="daterange" range-separator="-" start-placeholder="生效日期"
              end-placeholder="失效日期" value-format="yyyy-MM-dd" @change="idDatetChange"></el-date-picker>
            <div class='switchContainer'>
              长期：<el-switch v-model="form.longItem" @change="idcardenddateChange" active-color="#409eff" inactive-color="#f0f3f8"></el-switch>
            </div>
          </el-form-item>


          <el-form-item label="身份证反面">
            <el-upload class="avatar-uploader" :action="baseURL + 'oasystem/uploadimg'" name="idcardreverse" :headers="myHeaders"
              :on-success="handleAvatarSuccess2">
              <img v-if="form.idcardreverse" :src="form.idcardreverse" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>

          <el-form-item label="银行卡号码" style="width: 33.3%;" v-if="form.wtype == 2">
            <el-input v-model="form.bankcard"></el-input>
          </el-form-item>

          <el-form-item label="银行卡开户行" style="width: 33.3%;" v-if="form.wtype == 2">
            <el-input v-model="form.bankname"></el-input>
          </el-form-item>

          <el-form-item label="银行卡" v-if="form.wtype == 2" style="width: 33.3%;">
            <el-upload class="avatar-uploader" :action="baseURL + 'oasystem/uploadimg'" name="bankcardfront" :headers="myHeaders"
              :on-success="handleAvatarSuccess3">
              <img v-if="form.bankcardfront" :src="form.bankcardfront" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>

          <el-form-item label="合同照片" style="width: 100%;">
            <el-upload class="avatar-uploader" :action="baseURL + 'oasystem/uploadimg'" name="contractimg" :headers="myHeaders"
            :on-preview="handlePictureCardPreview"
              ref="upload" :on-success="handleAvatarSuccess4" list-type="picture-card" :on-remove="handleRemove">
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>

        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="formSubmit">提 交</el-button>
      </span>
    </el-dialog>


    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>


    <el-dialog title="信息采集录入" :visible.sync="dialogVisible2" width="100%" class='dialog2' center>
      <el-form ref="infos" :model="infos" label-width="95px" :rules="rules">

        <el-form-item label="姓名" prop="fullname">
          <el-input v-model="infos.fullname"></el-input>
        </el-form-item>

        <el-form-item label="电话" prop="telephone">
          <el-input v-model="infos.telephone" type='number'></el-input>
        </el-form-item>

        <el-form-item label="性别" prop="sex_cn">
          <el-select v-model="infos.sex_cn" placeholder="请选择性别" @change='sexSelectChange'>
            <el-option :label="item.name" :value="[item.id,item.name]" v-for='(item,index) in sexList' :key='index'></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="出生年份" prop="birthdate">
          <el-date-picker v-model="infos.birthdate" type="year" value-format="yyyy" placeholder="选择出生年份">
          </el-date-picker>
        </el-form-item>


        <el-form-item label="招聘专员" prop="adminname">
          <el-select v-model="infos.adminname" placeholder="请选择招聘专员" @change='recommendChange' :disabled='disabledState'>
            <el-option :label="item.oausername" :value="[item.uid,item.oausername,item.id]" v-for='(item,index) in recommendList'
              :key='index'></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="面试工厂">
          <el-select v-model="infos.company_name" placeholder="请选择面试工厂" @change='companyChange' filterable>
            <el-option :label="item.companyname" :value="[item.id,item.companyname]" v-for='(item,index) in companyList'
              :key='index'></el-option>
          </el-select>
        </el-form-item>


        <el-form-item label="面试职位" prop="jobs_name">
          <el-select v-model="infos.jobs_name" placeholder="请选择面试职位" filterable @change='selectJobs'>
            <el-option :label="item.jobs_name" :value="[item.id,item.jobs_name]" v-for='(item,index) in selectCompanyList'
              :key='index'></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="面试日期">
          <el-date-picker v-model="infos.interview_time" type="datetime" value-format="yyyy-MM-dd HH:mm" placeholder="请选择面试日期">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="上车地点">
          <el-select v-model="infos.shop_name" placeholder="请选择上车地点" @change="shopSelectChage">
            <el-option :label="item.name" :value="[item.id,item.name]" v-for='(item,index) in shopList' :key='index'></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="上车位置" v-if="infos.shop_id == 1">
          <el-input v-model="infos.shop_remark" type='text' placeholder='输入上车位置'></el-input>
        </el-form-item>

        <el-form-item label="应收车费">
          <el-input v-model="infos.fee" type='number' placeholder='输入车费'></el-input>
        </el-form-item>


        <el-form-item label="备注">
          <el-input v-model="infos.remark" placeholder='输入备注'></el-input>
        </el-form-item>


      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm('infos')" v-if="state == 1">提交</el-button>
        <el-button type="primary" @click="submitForm1('infos')" v-if="state == 2">修改提交</el-button>
        <el-button type="primary" @click="submitForm2('infos')" v-if="state == 3">转推提交</el-button>
      </span>
    </el-dialog>


    <el-dialog title="不合适详情" :visible.sync="dialogReason" width="30%">
      <div class="containerReason">
        <el-input type="textarea" placeholder="请输入内容" v-model="reason" class='textareaInput'> </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm3">提交</el-button>
      </span>
    </el-dialog>

    <el-dialog title="更换招聘专员" :visible.sync="recommendDialog" width="30%">
      <div class="containerReason">
        <div class="recommendItem">
          <div class="title">原招聘专员：</div>
          <div class="selectName">{{selectName}}</div>
        </div>
        <div class="recommendItem">
          <div class="title">更换专员为：</div>
          <div class="selectName">
            <el-select v-model="recommendInfo.adminname" placeholder="请选择招聘专员" @change='recommendChanges'>
              <el-option v-for="item in recommendList" :key="item.uid" :label="item.oausername" :value="[item.uid,item.oausername,item.id]"></el-option>
            </el-select>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm4">提交</el-button>
      </span>
    </el-dialog>

    <!-- 查看简历信息 start -->
        <el-dialog class="el-dialog-medium" title="简历信息" :visible.sync="dialogVisibleResume" width="100%"  center>
          <div class="resume-details-container" style="min-height: 500px;">
            <div class="e-update-date">
              <div class="update-date">更新时间：{{resumeDetailsInfo_user.refreshtime}}</div>
            </div>

            <el-tabs v-model="activeTabName" @tab-click="handleResumeTabChange()">
              <el-tab-pane label="简历档案" name="first">
                <div>
                  <div class="resume-info">
                    <div class="info-left">
                      <div class="i-item">姓名：{{resumeDetailsInfo_user.fullname}}</div>
                      <div class="i-item">手机号码：{{resumeDetailsInfo_user.telephone}}</div>
                      <div class="i-item">性别：{{resumeDetailsInfo_user.sex_cn}}</div>
                      <div class="i-item">出生年份：{{resumeDetailsInfo_user.birthdate}}年</div>
                    </div>
                    <div class="info-right">
                      <div class="i-item">现居地：{{resumeDetailsInfo_user.address}}</div>
                      <div class="i-item">意向工作：{{resumeDetailsInfo_user.intention_jobs_cn1}} / {{resumeDetailsInfo_user.intention_jobs_cn2}}/{{resumeDetailsInfo_user.intention_jobs_cn3}} </div>
                      <div class="i-item">意向区域：{{resumeDetailsInfo_user.district_cn1}} / {{resumeDetailsInfo_user.district_cn2}} / {{resumeDetailsInfo_user.district_cn3}}</div>

                    </div>
                  </div>

                  <div class="row-line"></div>

                  <div class="resume-info">
                    <div class="info-left">
                      <div class="i-item">招聘专员：{{resumeDetailsInfo_user.adminname}}</div>
                      <div class="i-item">录入时间：{{resumeDetailsInfo_user.addtime}}</div>
                      <div class="i-item">推荐面试工厂：{{resumeDetailsInfo_interview.company_name}}</div>
                      <div class="i-item">面试岗位：{{resumeDetailsInfo_interview.jobs_name}}</div>
                    </div>
                    <div class="info-right">
                      <div class="i-item">面试时间：{{resumeDetailsInfo_interview.interview_time}}</div>
                      <div class="i-item">上车地点：{{resumeDetailsInfo_interview.shop_name}}</div>
                      <div class="i-item">应收车费：{{resumeDetailsInfo_interview.fee || 0}}</div>
                      <div class="i-item">备注：{{resumeDetailsInfo_interview.remark}}</div>
                    </div>
                  </div>




                </div>

              </el-tab-pane>
              <el-tab-pane label="面试详情" name="second">
                <div class="interview-history" >
                  <div class="el-steps el-steps--vertical">
                    <div v-for="(item,index) in resumeDetailsInfo_history" class="el-step is-vertical" style="flex-basis: 50%;">
                      <div class="el-step__head is-finish">
                        <div class="el-step__line" style="margin-right: 0px;">
                          <i class="el-step__line-inner" style="transition-delay: 0ms; border-width: 0px; height: 0%;"></i>
                        </div>
                        <div class="el-step__icon is-text">
                          <div class="el-step__icon-inner">{{index+1}}</div>
                        </div>
                      </div>
                      <div class="el-step__main">
                        <div class="el-step__title is-finish">
                          <div class="i-company" >{{item.content}}</div>
                          <div class="i-time" >{{item.addtime}}</div>
                        </div>
                        <div class="el-step__description is-finish"></div>
                      </div>
                    </div>

                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>


          </div>
        </el-dialog>
    <!--     查看简历信息 end -->


  </div>
</template>

<script>
  import Message from '@/utils/message.js';
  export default {
    data() {
      return {
        tableData: [],
        total: 1,
        dialogVisible1: false,
        dialogVisible2: false,
        dialogReason: false,
        disabledState: false,
        reason: '',
        form: {
          resume_name: '',
          value1: '',
          entry_time: '',
          wtype: 2,
          idcard: '',
          idcardfront: '',
          idcardreverse: '',
          bankcard: '',
          bankcardfront: '',
          bankname: '',
          contractimg: [],
          longItem:false,
          idcardtime:[]
        },
        imageUrl: '',
        selectId: '',
        sexList: [{
          name: '男',
          id: 1
        }, {
          name: '女',
          id: 2
        }],
        shopList: [],
        companyList: [],
        recommendList: [],
        state: 1, //1新录，2修改，3转推
        info: {
          page: 1,
          status: '', //0无操作，1待接送，2待面试，3面试不通过，4待入职，5入职，6离职
          key_type: '', //1:姓名，2电话号码，3面试工厂，4面试职位，5招聘专员
          key: '',
          begintime: '',
          endtime: '', //面试时间
          begintime2: '',
          endtime2: '', //录入时间
          idcardstartdate: '',
          idcardenddate: '',
          idcardtime: [],
          begintimeArray: [],
          begintimeArray2: [],
          company_id:''
        },
        infos: {
          fullname: '',
          telephone: '',
          sex_cn: '',
          sex: '',
          birthdate: '',
          remark: '',
          fee: '',
          company_id: '',
          company_name: '',
          shop_id: '',
          shop_name: '',
          jobs_name: '',
          interview_time: '',
          adminname: '',
          shop_remark: ''
        },
        rules: {
          fullname: [{
            required: true,
            message: '请填写用户名',
            trigger: 'blur'
          }],
          telephone: [{
            required: true,
            message: '请填写用户电话',
            trigger: 'blur'
          }],
          sex_cn: [{
            required: true,
            message: '请选择性别',
            trigger: 'change'
          }],
          birthdate: [{
            required: true,
            message: '请选择出生年份',
            trigger: 'change'
          }],
          adminname: [{
            required: true,
            message: '请选择招聘专员',
            trigger: 'change'
          }]
        },
        myHeaders: {},
        selectIds: '',
        recommendDialog: false,
        selectName: '',
        recommendInfo: {
          user: [],
          adminname: '',
          adminid: '',
          resume_id: '',
        },
        selectCompanyList: [],
        dialogVisible:false,
        dialogImageUrl:'',
        timeList:[],
        systemList:[],
        dialogVisibleResume:false,//查看员工简历信息
        activeTabName:"first",
        resumeDetailsInfo_user:{},//简历档案-用户信息
        resumeDetailsInfo_interview:{},//简历档案-最后面试
        resumeDetailsInfo_history:[],//面试详情 - 历史面试信息
        resumeDialogParam:{
          resume_id:'',//简历id
          did:"",//面试id
        }
      }
    },
    created() {
      this.$nextTick(() => {
        document.onselectstart = new Function("event.returnValue=false");
      });
    },
    mounted() {
      this.getTableData()
      this.getCompanyList()
      this.getShopList()
      this.getRecommendList()
      let token = this.$store.state.token;
      let token_type = this.$store.state.token_type;
      this.myHeaders = {
        authorization: token_type + " " + token,
      };
    },
    methods: {


      handlePictureCardPreview(file) {
         this.dialogImageUrl = file.url;
         this.dialogVisible = true;
      },

      idcardenddateChange(e){
          e?this.form.idcardenddate = '长期':this.form.idcardenddate
      },

      selectJobs(e) {
        this.infos.jobs_id = e[0]
        this.infos.jobs_name = e[1]
      },

      getJobsList() {
        this.gets('category/jobslist', {
          company_id: this.infos.company_id
        }).then(res => {
          this.selectCompanyList = res.data.data
        })
      },

      handleRemove(e) {
        let item = e.response.data.img
        let index = this.form.contractimg.indexOf(item)
        this.form.contractimg.splice(index, 1)
        console.log(this.form.contractimg)
      },

      exportData() {
        this.gets('oasystem/waitentrylistdc', this.info).then(res => {
          var tempwindow = window.open('_blank')
          tempwindow.location = res.data
        })
      },

      recommendChanges(val) {
        this.recommendInfo.adminid = val[0]
        this.recommendInfo.adminname = val[1]
        this.recommendInfo.utypeid = val[2]
        this.$forceUpdate()
      },

      submitForm4() {
        this.recommendInfo.resume_id = this.selectId
        if (!this.recommendInfo.adminid) {
          return Message.success('请选择招聘专员')
        }
        this.post('oasystem/setmanage', this.recommendInfo).then(res => {
          if (res.data.code == 1) {
            Message.success(res.data.msg)
          } else {
            Message.warning(res.data.msg)
          }
          this.recommendInfo = {}
          this.recommendDialog = false
          this.getTableData()
        })
      },

      submitForm3() {
        let info = {}
        let that = this
        info.status = 3
        info.reason = this.reason
        info.did = this.selectIds
        if (!info.reason) {
          return Message.warning('请输入原因')
        }
        this.post('oasystem/setinterviewresult', info).then(res => {
          if (res.data.code == 1) {
            Message.success(res.data.msg)
            this.dialogReason = false
          } else {
            Message.warning(res.data.msg)
          }
          this.getTableData()
        })
      },

      idDatetChange(val) {
        this.form.idcardstartdate = val[0]
        this.form.idcardenddate = this.form.longItem?'长期':val[1]
        console.log(this.form)
      },

      infoChange(val) {
        this.disabledState = true
        this.gets('oasystem/resumeinfo', {
          resume_id: val
        }).then(res => {
          let resumeInfo = res.data.data.resumeinfo
          let interviewinfo = res.data.data.interviewinfo
          this.infos.fullname = resumeInfo.fullname
          this.infos.sex_cn = resumeInfo.sex_cn
          this.infos.sex = resumeInfo.sex
          this.infos.telephone = resumeInfo.telephone
          this.infos.birthdate = resumeInfo.birthdate + ''
          this.infos.fullname = resumeInfo.fullname
          this.infos.adminname = resumeInfo.adminname
          this.infos.adminid = resumeInfo.adminid
          this.infos.company_name = interviewinfo.company_name
          this.infos.company_id = interviewinfo.company_id
          this.infos.interview_time = interviewinfo.interview_time
          this.infos.shop_id = interviewinfo.shop_id
          this.infos.shop_name = interviewinfo.shop_name
          this.infos.jobs_name = interviewinfo.jobs_name
          this.infos.fee = interviewinfo.fee
          this.infos.remark = interviewinfo.remark
          this.infos.interviewid = interviewinfo.did
          this.infos.shop_remark = interviewinfo.shop_remark
          this.infos.resume_id = val
          this.state = 2
          this.dialogVisible2 = true
        })

        this.gets('category/jobslist', {
          company_id: val.company_id
        }).then(res => {
          this.selectCompanyList = res.data.data
        })
      },

      changePage(val) {
        this.info.page = val
        this.getTableData()
      },

      inputNewList() {
        this.disabledState = false
        this.infos.fullname = ''
        this.infos.telephone = ''
        this.infos.sex_cn = ''
        this.infos.remark = ''
        this.infos.fee = ''
        this.infos.sex = ''
        this.infos.shop_name = ''
        this.infos.adminid = ''
        this.infos.shop_id = ''
        this.infos.interview_time = ''
        this.infos.company_name = ''
        this.infos.company_id = ''
        this.infos.jobs_name = ''
        this.infos.adminname = ''
        this.infos.birthdate = ''
        this.infos.interviewid = ''
        this.dialogVisible2 = true
      },

      getCompanyList() {
        this.gets('oasystem/catecompanylist').then(res => {
          this.companyList = res.data.data
        })
      },

      getShopList() {
        this.gets('oasystem/shoplist').then(res => {
          this.shopList = res.data.data
        })
      },

      getRecommendList() {
        this.gets('oasystem/cateadminlist').then(res => {
          this.recommendList = res.data.data
        })
      },

      workChange(val) {
        this.info.company_id = val
        this.getTableData()
      },

      interviewTimeChange(val) {
        this.info.begintime = val?val[0]:''
        this.info.endtime = val?val[1]:''
        this.info.page = 1
        this.getTableData()
      },

      inputTimeChange(val) {
        this.info.begintime2 = val?val[0]:''
        this.info.endtime2 = val?val[1]:''
        this.info.page = 1
        this.getTableData()
      },

      getTableData() {
        this.gets('oasystem/waitentrylist', this.info).then(res => {
          this.tableData = res.data.data.list
          this.total = res.data.data.total
        })
      },

      interviewResult(val, row) {
        let info = {}
        info.did = row.did
        info.status = val
        this.selectId = row.id
        this.selectIds = row.did
        this.$confirm('设置该用户的结果为' + (val == 3 ? "不入职" : "通过") + ', 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          info.reason = '不来入职'
          this.post('oasystem/setinterviewresult', info).then(res => {
            if (res.data.code == 1) {
              Message.success(res.data.msg)
              val == 3 ? '' : this.getUserInfo(row.did),
                this.getTableData()
            } else {
              Message.warning(res.data.msg)
            }
          })
        })
      },

      entryInfo(row) {
        this.selectId = row.id
        this.selectIds = row.did
        this.getUserInfo(row.did)
      },

      showReason() {
        this.dialogReason = true
        this.reason = ''
      },

      formSubmit() {
        this.form.idcarddatestatus = this.form.idcardenddate == '长期'?'2':'1'
        this.post('oasystem/entryadd', this.form).then(res => {
          if (res.data.code == 1) {
            Message.success(res.data.msg)
          } else {
           return Message.warning(res.data.msg)
          }
          this.$refs.upload.clearFiles()
          this.getTableData()
          this.dialogVisible1 = false
        })
      },

      getUserInfo(val) {
        this.form.resume_name = ''
        this.form.value1 = ''
        this.form.entry_time = ''
        this.form.wtype = ''
        this.form.idcard = ''
        this.form.idcardfront = ''
        this.form.idcardreverse = ''
        this.form.bankcard = ''
        this.form.bankname = ''
        this.form.bankcardfront = ''
        this.form.wtypeName = ''
        this.form.wtype = ''
        this.form.contract_begin = ''
        this.form.contract_end = ''
        this.form.idcardtime = []
        this.form.idcardstartdate = ''
        this.form.idcardenddate = ''
        this.form.contractimg = []
        this.gets('oasystem/resumeinfo', {
          resume_id: this.selectId,
          did: val
        }).then(res => {
          if (res.data.data) {
            this.dialogVisible1 = true
            let resumeinfo = res.data.data.resumeinfo
            let interviewinfo = res.data.data.interviewinfo
            this.form.resume_name = resumeinfo.fullname
            this.form.did = val
            let companyWorkTime = res.data.data.companyWorkTime
            this.timeList = []
            this.systemList = []
            companyWorkTime.resttype.map((item)=>{
              this.systemList.push({label:item == 1?'双休':item == 2?'单休':'大小周',id:item})
            })
            companyWorkTime.worktime.map((item)=>{
              this.timeList.push({label:`上班时间：${item.workbegin} --- ${item.workend} , 工作${item.workhours}小时`,id:item.id})
            })
            // this.form.adminname = resumeinfo.adminname
            // this.form.adminid = resumeinfo.adminid
            // this.form.interview_time = interviewinfo.interview_time.substring(0,10)
          }
        })
      },

      changeRecommend(row) {
        this.selectName = row.adminname
        this.selectId = row.id
        this.recommendDialog = true
      },

      searchResume() {
        if (!this.info.key_type) {
          return Message.warning('请选择搜索类型')
        }
        this.info.page = 1
        this.getTableData()
      },

      pushUser(val) {
        this.infos.fullname = ''
        this.infos.telephone = ''
        this.infos.sex_cn = ''
        this.infos.birthdate = ''
        this.infos.adminname = ''
        this.infos.company_name = ''
        this.infos.interview_time = ''
        this.infos.shop_name = ''
        this.infos.fee = ''
        this.infos.jobs_name = ''
        this.infos.remark = ''
        this.disabledState = true
        this.gets('oasystem/resumeinfo', {
          resume_id: val
        }).then(res => {
          let resumeinfo = res.data.data.resumeinfo
          this.infos.resume_id = val
          this.infos.fullname = resumeinfo.fullname
          this.infos.telephone = resumeinfo.telephone
          this.infos.sex_cn = resumeinfo.sex_cn
          this.infos.birthdate = resumeinfo.birthdate + ''
          this.infos.adminname = resumeinfo.adminname
          this.infos.adminid = resumeinfo.adminid
          this.dialogVisible2 = true
          this.state = 3
        })
      },

      getSearchBarHeight() {

      },

      handleAvatarSuccess4(res) {
        this.form.contractimg.push(res.data.img)
      },

      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.post('oasystem/addresume', this.infos).then(res => {
              if (res.data.code == 1) {
                Message.success(res.data.msg)
                this.dialogVisible2 = false
                this.info.page = 1
                this.getTableData()
              } else {
                Message.warning(res.data.msg)
              }
            })
          } else {
            return false;
          }
        });
      },

      submitForm1(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.post('oasystem/editinterview', this.infos).then(res => {
              if (res.data.code == 1) {
                Message.success(res.data.msg)
                this.dialogVisible2 = false
                this.state = 1
                this.getTableData()
              } else {
                Message.warning(res.data.msg)
              }
            })
          } else {
            return false;
          }
        });
      },

      submitForm2(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.post('oasystem/pushresumesubmit', this.infos).then(res => {
              if (res.data.code == 1) {
                Message.success(res.data.msg)
                this.dialogVisible2 = false
                this.state = 1
                this.getTableData()
              } else {
                Message.warning(res.data.msg)
              }
            })
          } else {
            return false;
          }
        });
      },


      shopSelectChage(val) {
        this.infos.shop_name = val[1]
        this.infos.shop_id = val[0]
        this.$forceUpdate()
      },

      sexSelectChange(val) {
        this.infos.sex = val[0]
        this.infos.sex_cn = val[1]
        this.$forceUpdate()
      },

      companyChange(val) {
        this.infos.company_name = val[1]
        this.infos.company_id = val[0]
        this.infos.jobs_name = ''
        this.infos.jobs_id = ''
        this.getJobsList()
        this.$forceUpdate()
      },

      recommendChange(val) {
        this.infos.adminid = val[0]
        this.infos.adminname = val[1]
        this.infos.utypeid = val[2]
        console.log(this.infos)
        this.$forceUpdate()
      },

      contractChange(val) {
        this.form.contract_begin = val[0]
        this.form.contract_end = val[1]
        this.$forceUpdate()
      },

      handleAvatarSuccess(res) {
        if (res.data.cardnum != '无效') {
          this.form.idcardfront = res.data.img
          this.form.idcard = res.data.cardnum
          this.$forceUpdate()
        } else {
          Message.warning('无效图片')
        }
      },

      handleAvatarSuccess2(res) {
        if (res.data.cardnum != '无效' && res.data.cardnum != '过期') {
          this.form.idcardreverse = res.data.img
          this.form.idcardenddate = res.data.cardnum.EndDate
          this.form.idcardstartdate = res.data.cardnum.StartDate
          let array = [res.data.cardnum.StartDate, res.data.cardnum.EndDate]
          if(this.form.idcardenddate == '长期'){
            this.form.longItem = true
          }
          this.form.idcardtime = array
        } else if (res.data.cardnum == '过期') {
          Message.warning('身份证过期')
        } else {
          Message.warning('无效图片')
        }
        this.$forceUpdate()
      },

      handleAvatarSuccess3(res) {
        if (res.data.cardnum != '无效') {
          this.form.bankcardfront = res.data.img
          this.form.bankcard = res.data.cardnum
          this.$forceUpdate()
        } else {
          Message.warning('无效图片')
        }
      },

      wtypeChange(val) {
        this.form.wtypeName = val == 1 ? '正式工' : '临时工',
          this.form.wtype = val
        if (val == 1) {
          this.form.contract_begin = ''
          this.form.contract_end = ''
          this.form.bankcard = ''
          this.form.bankname = ''
          this.form.bankcardfront = ''
        }
        this.$forceUpdate()
      },
      /****简历详情 start***********************/
      //显示简历详情
      openDialogResume(row) {
        this.dialogVisibleResume = true;
        this.resumeDialogParam.resume_id = row.id;
        this.resumeDialogParam.did = row.did;
        if(this.activeTabName=='first') {
          this.getResumeInfo()
        }else if(this.activeTabName=='second') {
          this.getInterviewHistory()
        }

      },
      //获取简历档案
      getResumeInfo() {
        this.gets('oasystem/resumeinfo', {resume_id:this.resumeDialogParam.resume_id,did:this.resumeDialogParam.did}).then(res => {
          if (res.data.code == 1) {
            this.resumeDetailsInfo_user = res.data.data.resumeinfo;
            this.resumeDetailsInfo_interview = res.data.data.interviewinfo|| {};

          } else {
            Message.warning(res.data.msg)
          }
        })
      },
      //获取简历信息 - 面试详情
      getInterviewHistory() {
        this.gets('v2/worker/operateList', {resume_id:this.resumeDialogParam.resume_id}).then(res => {
          if (res.data.code == 1) {
            this.resumeDetailsInfo_history = res.data.data;

          } else {
            Message.warning(res.data.msg)
          }
        })
      },
      handleResumeTabChange() {
        if(this.activeTabName=='first') {
          this.getResumeInfo()
        }else if(this.activeTabName=='second') {
          this.getInterviewHistory()
        }
      },
      /****简历详情 end***********************/

    }
  }
</script>

<style scoped>
  .addInfo {
    width: 100%;
    background: #fff;
    height: 80px;
    margin-top: 50px;
    display: flex;
    align-items: center;
    padding: 0 20px;
    box-sizing: border-box;
  }

  .container {
    margin-top: 30px;
    padding: 0 20px;
    box-sizing: border-box;
    background: #fff;
  }

  .btn {
    display: flex;
    flex-wrap: wrap;
  }

  .pagination {
    text-align: center;
    padding: 20px 0;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }

  .dialog1>>>.el-dialog {
    max-width: 1100px
  }

  .DialogListItem {
    display: flex;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 80px;
    line-height: 80px;
    text-align: center;
  }

  .avatar {
    width: 150px;
    height: 80px;
    display: block;
  }

  .dialog1>>>.el-form-item {
    min-width: 30%;
  }

  .dialog1>>>.el-upload {
    border: 1px dashed #d9d9d9;
  }

  .formContaier {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }

  .formContaier >>> .el-form-item{
    text-align: start;
    width: 45%;
  }


  .dialog2>>>.el-dialog {
    max-width: 600px
  }

  .dialog2>>>.el-input__inner {
    width: 100%;
  }

  .dialog2>>>.el-date-editor {
    width: 100%;
  }

  .textareaInput>>>textarea {
    height: 180px;
    resize: none;
  }

  .recommendItem {
    display: flex;
    align-items: center;
    margin-top: 20px;
  }

  .totalNumber {
    height: 50px;
    padding: 0 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }

  .switchContainer{
    position: absolute;
    bottom: -45px;
    left: 0;
  }
</style>
<style lang="scss" src="../../style/page/resumeDetails.scss"></style>



// WEBPACK FOOTER //
// src/view/oasystem/oawaitentrylist.vue